
import CertificateMD from "../ContractFarming/MarketingBoard/StampPaper/components/CertificateMD";
import ApprovedUnsigned from "../mainMenu/coReview/ApprovedUnsigned";
import MISPreviewScreen from "../mainMenu/MIS_MyApplication/MISPreviewScreen";
import PannelEnginnerDashboard from "../mainMenu/PannelEngineerDashboard";
import MISApproval from "../MIS_department/MIS_district/components/MISApproval";
import MISPreview from "../MIS_excel/input/components/MisPreview";
import RazorPay from "../pages/license-registration-form/razor_pay";
import PurchaseApmc from "../schemes/LandPurchaseSale/components/purchase/PurchaseApmc";


export const all_routes = {

  
  allDashboard: "/all-dashboard",
  PannelEnginnerDashboard:"/panel-engineer",
  GCADashboard:"/GCA-Dashboard",
  ssoWebLogin:"/ssoLogin/Trader",
  ssoWebPanel: "/ssoLogin/Panel_Engineer",

  // areaGrid: "/areaGridCreation",
  // gridAllotment: "/gridAllotment",
  reports: "/reports",
  Home: "/",
  AdminnDashboard: "/admin-dashboard",
  rectification:"/rectification",

  PendingApprovals:"/pending-approvals",
  Pendingjr:"/pending-jr-clerk",

  review: "/review",
  myApplication:"myApplication",
  application:"application",
  pendingReview: "/pendingReview",
  approvedReview: "/approvedReview",
  rejectedReview: "/rejectedReview",
  drReview: "/drReview",
  approvedSignedReview: "/approvedSignedReview",
  approvedUnSignedReview: "/approvedUnSignedReview",
  panelEngineerProfile:"/panelEngineerProfile",
  traderRectificationComponent:"/traderRectificationComponent",
  razorPay:"/razor_pay",

  // MIS
  misXLdownload:"/mis-get",
  misXLupload:"/mis-upload",
  misInput:"/mis-input",
  MISApproval: "/mis-approval",
  MISPreviewScreen: "/mis-preview",
  ApprovedMIS: "/mis-approved-application",
  PendingMIS: "/mis-pending-application",
  RaiseQueryMISMenu: "/mis-query-application",
  MISMyApplication: "/mis-my-application",
  MISAfterApproval: "/mis-after-approval",
  MISRaiseQuery: "/mis-raise-query",
  
  //apmc
  apmc:"/apmc",
  district:"/district",
  menu:"/menu",
  formApmcApplication:"/forms-application",
  allSchemes:"/allSchemes",
  jcForm:"/jcForm",
  downloadSchemes:"/downloadSchemes",
  districtRegistrar:"/districtRegistrar",
  landSchemes:"/landSchemes",
  purchaseApmc:"/purchase-apmc",
  sellApmc:"/sell-apmc",
  sellDistrict:"/sell-district",
  purchaseDistrict:"/purchase-district",
  allForms:"/allForms",
  districtAllForms:"/districtAllForms",
  schemeQuery:"/schemes-query",
  formQuery:"/forms-query",
  formQueryDistrict:"/forms-query-district",
  schemesQueryDistrict:"/schemes-query-district",
  classificationFormAPMC:"/classification-form-apmc",
  classificationFormDistrict:"/classification-form-district",

  //ONE TIME APPLICATION
  apmcDetailApplication:"/apmc-detail-application",
  myApmcOneTimeApplication:"/my-apmc-one-time-application",
  myApmcOneTimeApplicationPreview:"/my-apmc-detail-application-preview",
  apmcPreviewDepartment:"/apmc-preview-department",
  pendingOneTime:"/pending-one-time",
  approvedOneTime:"/approved-one-time",
  raiseQueryOneTime:"/raise-one-time",

  //contract farming
  sponsorRegistration:"/sponsor-registration",
  paymentSuccess:"/payment-status",
  registrationStatus:"/registration-status",
  marketingBoardRegistration:"/marketing-board-registration",
  sponsorAgreement:"/sponsor-agreement",
  mbAgreement:"/marketing-board-agreement",
  menuMarketingBoardAgreement:"/marketing-board-agr-menu",
  sponsorRegistrationPending:"/sponsor-registration-pending",
  sponsorRegistrationRaiseQuery:"/sponsor-registration-raiseQuery",
  sponsorRegistrationApproved:"/sponsor-registration-approved",
  sponsorAgreementPending:"/sponsor-agreement-pending",
  sponsorAgreementRaiseQuery:"/sponsor-agreement-raiseQuery",
  sponsorAgreementApproved:"/sponsor-agreement-approved",
  menuMarketingBoardReg:"/marketing-board-reg-menu",
  sponsorDashboard:"/sponsor-menu",
  stampPaperSponsor:"/sponsor-stamp",
  certificateMD:"/certificate-MD",
  pdfDocReview: "/Document-Review",
  spoRegMenu: "/sponsor-reg-menu",
  agreFormDownload: "/agreement-form-download",
  
  
  //page module

  licenseRegistrationForm:"/license-registration",
  panelRegistrationForm:"/license",
  PdfLoader:"/pdfloader",
  PaymentStatus:"/payment-status",
  Preview:"/application/preview",


//gca-Application
gcaLicenseRegistrationForm:"/gca-license-registration-form",

//preview
  previewAppDepartment:"/application-preview",
  previewPanelAppDepartment:"/application-preview-panel",
  previewGcaAppDepartment:"/gca-application-preview",
  approveGca:"/gca-application-approve",
  pendingGca:"/gca-application-pending",
  rejectionGca:"/gca-application-rejection",


//JC

  pending: "/application-pending",
  pending_panel: "/panel-application",
  paymentInitiate:"/paymnet",

  // pendingAtCoDr:"/application-approved-and-forwarded",
  pendingResubmission:"/application-pendinng-resubmission",
  pendingAtCoResubmission:"/application-approved-resubmission",
  forRejection:"/forward-trader-for-resubmission",
  approveUnsigned:"/approve-unsigned",
  // PendingAtDr:"/application-approved-and-forwarded",
  pendingAtDrResubmission:"/application-approved-resubmission",
  toClerkAfterRejection:"/application-rejection",
  firstapproved:"/approval",
  rejection:"/rejection",
  panelRejection:"/rejected",
  panelApproved:"/approved",
  toClerkAfterApproval:"/application-approved",
  approvedResubmission:"/approved-resubmission",

  apmcPendingApp: "/apmc-application",
  apmcApprovedApp:"/approved-apmc-application",
  apmcRejectedApp:"/rejected-apmc-application",
  apmcFormsPendingApp: "/apmc-forms-application",
  apmcFormsApprovedApp:"/approved-apmc-forms-application",
  apmcFormsRejectedApp:"/rejected-apmc-forms-application",

 //CO

  // myApplication: "/my-application",
  traderPending:"/my-applications",
  GcaMyApplication:"/gca-my-application",
  previewOneApplication:"/application/:applicationId",
  previewGcaOneApplication:"/gca-application/:applicationId",
  previewPanelApplication:"/panel-application/:applicationId",
  paymentStatus:"/application-status/:applicationId",
  applicationDownload:"/downloadApplication",
  approve: "/approve",
  reject: "/reject",
  resubmission: "/resubmision",
  approved: "/approved",
  rejected: "/rejected",
 
  myApplicationPanel:"/myApplicationPanel",
  pendingPanel: "/pendingPanel",
  approvedPanel: "/approvedPanel",
  rejectedPanel: "/rejectedPanel",
  profile: "/profile",
  
  error404: "/error-404",
  aboutNew: "/about-details",
  error500: "/error-500",
  apikey: "/api-keys",
 
  // auth routes routes
 
  login2: "/login",
  // register: "/register-1",
  // register2: "/register-2",
  resetPasswordModal:"/resetPasswordModal",
  register3: "/register",
  forgotPassword3: "/forgot-password-3",
  twoStepVerification3: "/user-verification",
  emailVerification3: "/email-verification-3",
  resetPassword3: "/reset-password-3",
  resetPasswordSuccess3: "/success-3",
  //APMC
  manage_apmc: "/manage-apmc",
  //ADMINISTRATION
 
  manage_approval: "/manage-approval",
};
